module.exports = new __parcel__URL__("tabs_en.4d3be7ee.webp").toString();